import { createTheme } from "@material-ui/core/styles";
import useColors from "../../../../hooks/personalization/useColors";

export default () => {
  const { primaryColor, secondaryColor } = useColors();
  return createTheme({
    overrides: {
      MuiFormControl: {
        root: {
          width: "100%",
        },
      },
      MuiIconButton: {
        root: {
          color: secondaryColor,
        },
      },
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: secondaryColor,
        },
      },
      MuiButton: {
        textPrimary: {
          color: secondaryColor,
          fontWeight: "bold",
          fontSize: "1rem",
        },
      },
      MuiPickersDay: {
        daySelected: {
          backgroundColor: primaryColor,
          "&:hover": {
            backgroundColor: primaryColor,
          },
        },
        current: {
          border: `1px solid ${secondaryColor}`,
          borderRadius: "50%",
        },
      },
      MuiPickersClock: {
        pin: {
          backgroundColor: secondaryColor,
        },
      },
      MuiPickersClockPointer: {
        pointer: {
          backgroundColor: secondaryColor,
        },
        thumb: {
          border: `14px solid ${primaryColor}`,
        },
      },
      MuiPickerDTTabs: {
        tabs: {
          backgroundColor: secondaryColor,
        },
      },
    },
  });
};
